import { AutomationStatus } from '@repo/utils';
import { Alert, type AlertProps } from 'antd';
import { CANVAS_ALERT_MESSAGES } from 'automations/data/canvasAlert';
import { useAutomationDispatch } from 'automations/hooks/useAutomationDispatch';
import {
  automationStatusSelector,
  canvasAlertSelector, isLiveEditEnabledSelector,
} from 'automations/selectors/automationConfig';
import { setCanvasAlert } from 'automations/store/automationConfigSlice';
import { useSelector } from 'react-redux';

import styles from './AutomationCanvas.module.scss';

export default function CanvasAlert() {
  const dispatch = useAutomationDispatch();

  const isLiveEditEnabled = useSelector(isLiveEditEnabledSelector);
  const automationStatus = useSelector(automationStatusSelector);
  const canvasAlert = useSelector(canvasAlertSelector);

  let content: AlertProps | undefined;
  if (canvasAlert?.message) {
    content = canvasAlert;
  } else if (isLiveEditEnabled) {
    content = CANVAS_ALERT_MESSAGES?.liveEdit;
  } else if (automationStatus === AutomationStatus.unpublished) {
    content = CANVAS_ALERT_MESSAGES?.unpublished;
  }

  if (!content) return null;

  return (
    <Alert
      className={styles.canvasAlert}
      closable
      showIcon
      onClose={() => dispatch(setCanvasAlert(undefined))}
      {...content}
    />
  );
}
